import { render, staticRenderFns } from "./ChapterQuiz.vue?vue&type=template&id=bc0be370"
import script from "./ChapterQuiz.vue?vue&type=script&lang=js"
export * from "./ChapterQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports